let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8hyuR")).then(() => parcelRequire('RiK2l'));